export const getCleanedFileName = (filename: string) => {
    const split = filename.split('.');
    const extension = split.pop();
    const noExtension = split.join('');
    const cleaned = noExtension.replace(/[^æøå\w -]+/g, '').replace(/ /g, '-');

    return `${cleaned}.${extension}`;
};
